import React from 'react';
import {ScrollView, View, Image, StyleSheet} from 'react-native';
import {useInnerStyle} from '../invitation.style.hooks';
import theme from '@/style';
import DetailNavTitle from '@/components/business/detail-nav-title';
import InvitationRuleTable from './invitation-rule-table';
import {goBack} from '@/utils';

// 顶部图片本地资源
const bannerImg = require('@/assets/imgs/invitation/header.webp');
const rulesImg = require('@/assets/imgs/invitation/rules.webp');
const rewardImg = require('@/assets/imgs/invitation/reward-header.webp');

const PAGE_BG_COLOR = '#7B4016';

const InvitationRule = () => {
  const {
    size: {screenHeight, screenWidth},
  } = useInnerStyle();
  return (
    <View
      style={[
        {height: screenHeight, backgroundColor: PAGE_BG_COLOR},
        theme.fill.fillW,
        theme.flex.col,
      ]}>
      <DetailNavTitle
        hideAmount
        serverRight
        title="Invitation Rules"
        onBack={goBack}
      />
      <ScrollView style={[theme.flex.flex1]}>
        {/* 顶部Banner图片 */}
        <div className="flex flex-col absolute top-0 left-0 right-0">
          <Image
            source={bannerImg}
            style={{
              width: screenWidth,
              height: (screenWidth / 375) * 812,
            }}
            resizeMode="cover"
          />
        </div>
        {/* 规则说明与步骤说明合并卡片 */}
        <div className="flex flex-col px-4 mt-[20.625rem]">
          <View style={styles.rulesImgWrap}>
            <Image
              source={rulesImg}
              style={styles.rulesImg}
              resizeMode="cover"
            />
          </View>
          <View style={styles.rewardImgWrap}>
            <Image
              source={rewardImg}
              style={styles.rewardImg}
              resizeMode="cover"
            />
          </View>
          <InvitationRuleTable />
        </div>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  gradientTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#c9b65b',
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#c9b65b',
    textAlign: 'center',
  },
  bullet: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#c9b65b',
    marginRight: 8,
  },
  stepText: {
    color: '#c9b65b',
    fontSize: 12,
  },
  ruleDesc: {
    color: '#c9b65b',
    fontSize: 12,
    textAlign: 'left',
    marginBottom: 8,
  },
  rulesImgWrap: {
    width: '100%',
    borderRadius: 16,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#d0bd88',
    backgroundColor: '#5d1b3f',
    marginBottom: 16,
    // 可选：添加阴影
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 2,
  },
  rulesImg: {
    width: '100%',
    aspectRatio: 1022 / 822, // 按原图比例
    height: undefined,
    minHeight: 120,
    maxHeight: 400,
    display: 'flex',
  },
  rewardImgWrap: {
    width: '100%',
    marginBottom: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rewardImg: {
    aspectRatio: 440 / 2 / (47 / 2),
    height: 47 / 2,
    resizeMode: 'contain',
    display: 'flex',
  },
});

console.log(styles);
export default InvitationRule;
